import { IS_DEV_APP } from '@/lib/env';

/** Persistent strip so a Dev build cannot be mistaken for production. */
export function DevAppBanner() {
  if (!IS_DEV_APP) return null;

  return (
    <div
      role="status"
      className="fixed left-0 right-0 top-0 z-[200000] bg-amber-400 text-center font-extrabold uppercase tracking-wider text-black"
      style={{
        paddingTop: 'max(10px, env(safe-area-inset-top))',
        paddingBottom: 7,
        fontSize: 12,
        boxShadow: '0 2px 8px rgba(0,0,0,0.25)',
      }}
    >
      DEV · not production
    </div>
  );
}
